import React, { useContext, createContext } from 'react';
import { noop } from 'lodash';

import {
  CandidateProfileReturnType,
  useCandidateProfile as useCandidateProfileInternal,
} from 'hooks/useCandidateProfile';

const initialContext: CandidateProfileReturnType = {
  candidateDemographicInfo: {
    gender: '',
    physical_disability: '',
    congnitive_disability: '',
    socio_economic_status: '',
    ethnicities: [],
  },
  setCandidateDemographicInfo: noop,
  updateCandidate: () => new Promise(noop),
  generateCV: () => new Promise(noop),
  updateUniversity: () => new Promise(noop),
  userInfoStatus: [],
  toggleUserInfoCompleteStatus: noop,
  completedTopics: 0,
  percentCompleted: 0,
  basicInfoComplete: false,
  educationComplete: false,
  experienceComplete: false,
  extraCurricularComplete: false,
  skillsComplete: false,
  demographiclInfoComplete: false,
  isProfileCompExceptDemographics: false,
};

const CandidateProfileContext =
  createContext<CandidateProfileReturnType>(initialContext);

export const useCandidateProfile = (): CandidateProfileReturnType =>
  useContext(CandidateProfileContext);

export const CandidateProfileProvider: React.FC = ({ children }) => {
  const value = useCandidateProfileInternal();

  return (
    <CandidateProfileContext.Provider value={value}>
      {children}
    </CandidateProfileContext.Provider>
  );
};
